/*
 * Copyright (c) 2022 biocrates life sciences ag, All rights reserved.
 */

import {ColumnWidth} from "./columnWidth"
import TableColumn from "./tableColumn"
import TableData from "./tableData"
import TableRow from "./tableRow"
import {TableSorting} from "./tableSorting"
import {TableFiltering} from "./tableFiltering"

// TODO: change name to something more suitable?
export default class SortableTableData extends TableData<
    TableColumn,
    TableRow
> {
    sorting: TableSorting[]

    filtering: TableFiltering[]

    colWidths: ColumnWidth[]

    constructor(
        columns: TableColumn[] = [],
        rows: TableRow[] = [],
        sorting: TableSorting[] = [],
        filtering: TableFiltering[] = [],
        colWidths: ColumnWidth[] = []
    ) {
        super(columns, rows)
        this.sorting = sorting
        this.filtering = filtering
        this.colWidths = colWidths
    }
}
